export default __webpack_public_path__ + "static/media/samsung_S7.b57d5a16.png";